import * as tslib_1 from "tslib";
import * as React from 'react';
import DiagnosticsCharm from './DiagnosticsCharm';
import { FeatureFlagsCharmStub } from './charmStubs';
import FeedbackCharm from './FeedbackCharm';
import HelpCharm from './HelpCharm';
import PremiumOlkCharm from './PremiumOlkCharm';
import SettingsCharm from './SettingsCharm';
import WaffleCharm from './WaffleCharm';
import SkypeCharm from './SkypeCharm';
import GetStartedCharm from './GetStartedCharm';
import WhatsNewCharm from './WhatsNewCharm';
import TodoCharm from './TodoCharm';
import HeaderPersona from './HeaderPersona';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isFrameworkFeatureEnabled } from 'owa-feature-flags';
import { observer } from 'mobx-react';
import { searchStore as searchStoreV1 } from 'owa-mail-search-store';
import { getScenarioStore, SearchScenarioId } from 'owa-search';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import HeaderBase from './HeaderBase';
import MergedNotificationPane from './MergedNotificationPane';
export function getEnterpriseRightHeaderCharms() {
    return tslib_1.__spread(getFeatureDiscoveryCharm(), [getDiagnosticCharm(), getMergedNotificationPane()]);
}
function getDiagnosticCharm() {
    return isFrameworkFeatureEnabled('fwk-devTools') && React.createElement(DiagnosticsCharm, { key: "diagnostics" });
}
function getMergedNotificationPane() {
    return (React.createElement(MergedNotificationPane, { key: "notificationPane", offset: {
            top: '48px',
            right: '0px',
        } }));
}
function getFeatureDiscoveryCharm() {
    return [
        isControlFeatureEnabled('auth-getStarted') && React.createElement(GetStartedCharm, { key: "getstarted" }),
        isControlFeatureEnabled('whatsNew-Pane') && React.createElement(WhatsNewCharm, { key: "whatsnew" }),
    ];
}
var Header = /** @class */ (function (_super) {
    tslib_1.__extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        var searchStore = isMailFeatureEnabled('sea-commonSearchBox')
            ? getScenarioStore(SearchScenarioId.Mail)
            : searchStoreV1;
        return (React.createElement(HeaderBase, { searchMode: !!searchStore.searchSessionGuid, headerLeftSectionStyle: this.props.headerLeftSectionStyle, leftCharms: [React.createElement(WaffleCharm, { key: "waffle" })], rightCharms: this.getConsumerRightHeaderCharms() }, this.props.children));
    };
    Header.prototype.getConsumerRightHeaderCharms = function () {
        return tslib_1.__spread([
            !isFrameworkFeatureEnabled('fwk-partner-code-off') &&
                (isControlFeatureEnabled('fwk-skypeConsumer') ||
                    isControlFeatureEnabled('fwk-skypeBusiness')) && React.createElement(SkypeCharm, { key: "skype" }),
            getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox &&
                isMailFeatureEnabled('auth-leftNavPremiumUpsell') && (React.createElement(PremiumOlkCharm, { key: "premium" })),
            isControlFeatureEnabled('todo-panel') && React.createElement(TodoCharm, { key: "todo" }),
            React.createElement(SettingsCharm, { key: "settings" })
        ], getFeatureDiscoveryCharm(), [
            React.createElement(HelpCharm, { key: "help" }),
            isControlFeatureEnabled('fwk-feedbackCharm') && React.createElement(FeedbackCharm, { key: "feedback" }),
            isFrameworkFeatureEnabled('fwk-devTools') && React.createElement(FeatureFlagsCharmStub, { key: "features" }),
            getDiagnosticCharm(),
            React.createElement(HeaderPersona, { key: "mePersona" }),
            getMergedNotificationPane(),
        ]);
    };
    Header = tslib_1.__decorate([
        observer
    ], Header);
    return Header;
}(React.Component));
export default Header;
//# sourceMappingURL=Header.js.map